import React from 'react'
import './spin.css';

function Spinner() {
  return (
    <div className="special-spinner">
        <span className="loader"></span>
    </div>
  )
}

export default Spinner